module.exports = __webpack_public_path__ + "media/天空地一体化智慧农业应用.22c44cce.mp4";